/**
 * useAuthData Composable
 * Provides convenient access to authenticated user data for all user qualities
 * - individuel: userData contains user-data entity
 * - collectif: userData + barData for bar entity
 * - firme: userData + firmData for firm entity
 */
export function useAuthData() {
  const authDataStore = useAuthDataStore()

  return {
    // Store instance
    authDataStore,

    // Direct state access
    userData: computed(() => authDataStore.userData),
    barData: computed(() => authDataStore.barData),
    firmData: computed(() => authDataStore.firmData),

    // User quality getters
    userQuality: computed(() => authDataStore.userQuality),
    isIndividuel: computed(() => authDataStore.isIndividuel),
    isCollectif: computed(() => authDataStore.isCollectif),
    isFirme: computed(() => authDataStore.isFirme),

    // Entity-aware getters (work across all qualities)
    entityData: computed(() => authDataStore.entityData),
    entityStatus: computed(() => authDataStore.entityStatus),
    entityType: computed(() => authDataStore.entityType),
    entityName: computed(() => authDataStore.entityName),

    // Original getters (for backward compatibility)
    documentId: computed(() => authDataStore.documentId),
    sugarId: computed(() => authDataStore.sugarId),
    userType: computed(() => authDataStore.userType),
    userStatus: computed(() => authDataStore.userStatus),
    fullname: computed(() => authDataStore.fullname),
    membershipContribution: computed(() => authDataStore.membershipContribution),

    // Actions
    setData: authDataStore.setData,
    clearData: authDataStore.clearData
  }
}
